"use client";
import { Footer, Nav } from "@/components/bnp-ui";

import PrivacyPolicy from "@/components/pages/auth/sign-up/PrivacyPolicy";
import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div>
      <Nav />
      <div className="p-4 lg:p-8">
        <h1 className="text-2xl text-main-900 font-semibold mb-8">
          Privacy Policy
        </h1>
        <PrivacyPolicy />
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
